import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const today = () => new Date().toISOString().slice(0, 10);

export const NewAppealDialog = ({ onClose, onSaved, riderId }) => {
  const [riders, setRiders] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [f, setF] = useState({ rider_id: riderId || "", assessment_id: "", kind: "appeal", received_date: today(), details: "" });
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v?.target ? v.target.value : v }));

  useEffect(() => { api.get("/riders").then((r) => setRiders(r.data)); }, []);
  useEffect(() => {
    if (f.rider_id) api.get("/assessments", { params: { rider_id: f.rider_id } }).then((r) => setAssessments(r.data));
  }, [f.rider_id]);

  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/appeals", { ...f, assessment_id: f.assessment_id || null });
      toast.success("Recorded");
      onSaved(data);
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto" data-testid="new-appeal-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Record appeal or complaint</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5"><Label>Rider</Label>
            <Select value={f.rider_id || undefined} onValueChange={(v) => setF((p) => ({ ...p, rider_id: v, assessment_id: "" }))}>
              <SelectTrigger data-testid="appeal-rider-select"><SelectValue placeholder="Select rider" /></SelectTrigger>
              <SelectContent>{riders.map((r) => <SelectItem key={r.id} value={r.id}>{r.last_name}, {r.first_name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5"><Label>Assessment concerned</Label>
            <Select value={f.assessment_id || undefined} onValueChange={set("assessment_id")}>
              <SelectTrigger data-testid="appeal-assessment-select"><SelectValue placeholder={assessments.length ? "Select assessment" : "No assessments"} /></SelectTrigger>
              <SelectContent>{assessments.map((a) => <SelectItem key={a.id} value={a.id}>{fmtDate(a.date)} · {a.assessor_name} · {a.outcome}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Type</Label>
              <Select value={f.kind} onValueChange={set("kind")}>
                <SelectTrigger data-testid="appeal-kind-select"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="appeal">Appeal</SelectItem><SelectItem value="complaint">Complaint</SelectItem></SelectContent>
              </Select>
            </div>
            <div className="space-y-1.5"><Label>Received</Label><Input type="date" value={f.received_date} onChange={set("received_date")} data-testid="appeal-date-input" /></div>
          </div>
          <div className="space-y-1.5"><Label>Details</Label><Textarea required rows={4} value={f.details} onChange={set("details")} data-testid="appeal-details-input" /></div>
          <div className="flex justify-end"><button type="submit" data-testid="appeal-save-btn" className="rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground">Save</button></div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
